import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AudioService } from 'src/services/audio.service';

@Component({
  selector: 'app-introcard',
  templateUrl: './introcard.component.html',
  styleUrls: ['./introcard.component.css']
})
export class IntrocardComponent implements OnInit {

  @ViewChild("cardwrapper", { read: ElementRef, static: true }) cardwrapper: ElementRef;
  
  constructor(public router: Router, public audioService: AudioService) { }

  @Input() item: any;
  
  ngOnInit(): void {
  }

  redirect(){
    this.router.navigate([this.item.RouterValue]);
  }
}
